import Vue from 'vue'
import { BootstrapVue, BSkeleton } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import VueApollo from 'vue-apollo'
import VOffline from 'v-offline'
import "../src/design/app.scss";
import store from '@/state/store'
import App from './App.vue'
import i18n from './i18n'
import tinymce from 'vue-tinymce-editor'
import { getTokenCurrentUser } from '@/utils/auth'
import { createUploadLink } from 'apollo-upload-client'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// const hosts = window.location.host.split('.')
// const h = hosts[0]
// hosts.splice(0, 1)
// console.log(hosts)
const httpLink = new createUploadLink({
  uri: `${window.location.protocol}//${window.location.host.split('.')[0]}.${process.env.VUE_APP_URL}/api`
})
const authMiddleware = new ApolloLink((operation, forward) => {
  const token = getTokenCurrentUser()
  if (token !== null){
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`
      }
    }))
  }
  return forward(operation)
})

const onErrorLink = onError(( {graphQLErrors, networkError, operation, forward}) => {
  if(graphQLErrors){
    graphQLErrors.forEach( ({ message, locations, path}) => {
      if(message === 'Signature has expired'){
        store.dispatch('authentication/logout')
        router.go('/login')
      }
    })
  }
})

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([onErrorLink, authMiddleware, httpLink]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

Vue.component('tinymce', tinymce)
Vue.use(VOffline)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.use(VueApollo)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)
Vue.component('b-skeleton', BSkeleton)

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
